//----------------CORE-----------------//
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
//----------------MUI-----------------//
import { makeStyles } from "@mui/styles";
//----------------MUI ICONS-----------------//
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import RouterIcon from "@mui/icons-material/Router";
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";

//----------------EXTERNAL COMPONENTS-----------------//
import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import RM from "components/Admin/roleManagement";
import UM from "components/Admin/userManagement";
import DM from "components/Admin/deviceManagement";
import GM from "components/Admin/groupManagement";
import Branding from "components/Branding";

const useStyles = makeStyles({
  root: { backgroundColor: "#eeeeee" },
  component: {
    backgroundColor: "#eeeeee",
    position: "absolute",
    top: "64px",
    left: "60px",
    padding: "20px 15px 20px 15px",
    minHeight: "calc(100vh - 64px)",
    minWidth: "calc(100vw - 60px)",
  },
});

export default function Manager(props) {
  const classes = useStyles();
  const metaDataValue = useSelector((state) => state.metaData);
  let previousUrl = "catalogue";
  let currentService = window.localStorage.getItem("currentService");
  if(currentService != "") {
    previousUrl = currentService;
  }


  function getPermission(chk) {
    let value;
    metaDataValue.appPaths.forEach((elm) => {
      if (elm.name == chk) {
        value = elm.permission;
      }
    });
    return value;
  }

  function getRoutes() {
    let newData = [];
    newData.push({
      icon: adminRoutes["Back Button"].icon,
      layout: adminRoutes["Back Button"].layout,
      name: adminRoutes["Back Button"].name,
      path: adminRoutes["Back Button"].path,
      permission: adminRoutes["Back Button"].permission,
    })
    metaDataValue.appPaths.forEach((elm) => {
      // Skip any Administration sub-tab with no adminRoutes entry (e.g. a stale/unknown tab
      // like "Billing"): adminRoutes[name].icon would otherwise throw and blank the WHOLE admin
      // layout. Unknown tabs are ignored; known tabs still render.
      if (elm.layout === "/administration/" && adminRoutes[elm.name]) {
        let temp = { ...elm };
        temp.icon = adminRoutes[temp.name].icon;
        temp.component = adminRoutes[temp.name].component;
        newData.push(temp);
      }
    });
    return newData;
  }

  const adminRoutes = {
    "Back Button": {
      icon: KeyboardReturnOutlinedIcon,
      layout: "/solutions/",
      name: "Back to Solution",
      path: previousUrl,
      permission: "ALL",
      redirectToSolution: true
    },
    "Device Management": {
      icon: RouterIcon,
      component: <DM permission={getPermission("Device Management")} />,
    },
    "User Management": {
      icon: GroupIcon,
      component: <UM permission={getPermission("User Management")} />,
    },
    "Role Management": {
      icon: AssignmentIndIcon,
      component: <RM permission={getPermission("Role Management")} />,
    },

    "Group Management": {
      icon: AccountTreeIcon,
      component: <GM permission={getPermission("Group Management")} />,
    },
    // Brand Management (taxonomy restructure): Branding moved under
    // Administration from the removed Settings module.
    "Brand Management": {
      icon: PaletteOutlinedIcon,
      component: <Branding permission={getPermission("Brand Management")} />,
    },
  };

  function getFirstRoute(chk) {
    let output = [];
    metaDataValue.appPaths.forEach((elm) => {
      // Only real admin routes count — mirrors the getRoutes/switchRoutes guard so an unknown
      // tab cannot leave output empty and make output[0].path throw.
      if (elm.layout === chk && adminRoutes[elm.name]) {
        output.push(elm);
      }
    });
    return output[0]?.path;
  }

  const firstAdminRoute = getFirstRoute("/administration/");
  const switchRoutes = (
    <Switch>
      {metaDataValue.appPaths.map((prop, key) => {
        if (prop.layout === "/administration/" && adminRoutes[prop.name]) {
          return (
            <Route path={prop.layout + prop.path} key={key}>
              {adminRoutes[prop.name].component}
            </Route>
          );
        }
        return null;
      })}
      {/* No navigable admin tab at all -> back to the catalogue (never a
          broken /administration/undefined). */}
      {firstAdminRoute ? (
        <Redirect to={`/administration/${firstAdminRoute}`} />
      ) : (
        <Redirect to="/solutions/catalogue" />
      )}
    </Switch>
  );

  return (
    <div className={classes.root}>
      <Sidebar routes={getRoutes()} />
      <Navbar
        routes={[
          ...metaDataValue.appPaths,
          ...[
            {
              name: "Solutions",
              path: "catalogue",
              layout: "/solutions/",
            },
          ],
        ]}
        services={metaDataValue.services}
        history={props.history}
      />
      <div className={classes.component}>{switchRoutes}</div>
    </div>
  );
}
